import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {ifCompletedInput} from "../../../utils/other";

class productionitemForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput type="number" name="qty" label="Darabszám" value={ this.props.values.qty }
                                   {...this.props.getFieldProps("productiondate")} saveChanges={this.props.setFieldValue}/>
                    </div>
                    <div className="col-md-6">
                        <DateTimeInput name="productiondate"
                                   label="Gyártás dátuma"
                                   {...this.props.getFieldProps("productiondate")}
                                   value={ this.props.values.productiondate }
                                   showTime={false} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(productionitemForm);
